module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w1000"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "commonForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "History (Years)",
      "prop": "CfYear"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CfYear),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfYear", _vm._n($$v))
      },
      expression: "formData.CfYear"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Annual output",
      "prop": "CfNum"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CfNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfNum", _vm._n($$v))
      },
      expression: "formData.CfNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Market share",
      "prop": "CfPer"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CfPer),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfPer", _vm._n($$v))
      },
      expression: "formData.CfPer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Number of tray experiments",
      "prop": "CfTest"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.CfTest),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfTest", _vm._n($$v))
      },
      expression: "formData.CfTest"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Global contact information",
      "prop": "CfGlobalInfo"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "textarea",
      "autosize": true
    },
    model: {
      value: (_vm.formData.CfGlobalInfo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfGlobalInfo", _vm._n($$v))
      },
      expression: "formData.CfGlobalInfo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Wechat QR Code",
      "prop": "CfWebQrcode"
    }
  }, [_c('img-upload', {
    attrs: {
      "size": "small",
      "tip": "Image recommended size：140*140"
    },
    model: {
      value: (_vm.formData.CfWebQrcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfWebQrcode", $$v)
      },
      expression: "formData.CfWebQrcode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "APP QR Code",
      "prop": "CfAppQrcode"
    }
  }, [_c('img-upload', {
    attrs: {
      "size": "small",
      "tip": "Image recommended size：140*140"
    },
    model: {
      value: (_vm.formData.CfAppQrcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfAppQrcode", $$v)
      },
      expression: "formData.CfAppQrcode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Rolling Guaranteed",
      "prop": "CfYouzhiCover"
    }
  }, [_c('img-upload', {
    attrs: {
      "size": "small",
      "tip": "Image recommended size：140*140"
    },
    model: {
      value: (_vm.formData.CfYouzhiCover),
      callback: function($$v) {
        _vm.$set(_vm.formData, "CfYouzhiCover", $$v)
      },
      expression: "formData.CfYouzhiCover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('commonForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-23869b28","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/config/ConfigForm.vue
// module id = 746
// module chunks = 1